/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SecurityScanResult } from '../models/SecurityScanResult';

export class SecurityScan {
  /**
  * Eon-assigned snapshot ID.
  */
  'snapshotId': string;
  /**
  * bottom line conclusion of the security scan.
  */
  'conclusion': SecurityScanConclusionEnum;
  /**
  * Date and time the scan was ended.
  */
  'createdTime': Date;
  /**
  * Confidence score from 0.0 to 1.0 indicating likelihood of the conclusion
  */
  'confidenceScore'?: number;
  /**
  * Explanation for this conclusion
  */
  'justification'?: string;
  /**
  * Type of detector that produced this conclusion
  */
  'detectorType'?: SecurityScanDetectorTypeEnum;
  /**
  * Total number of evidence instances across all result types
  */
  'totalEvidenceCount'?: number;
  /**
  * Detailed results of the security scan (capped to first 3 for REST API)
  */
  'results'?: Array<SecurityScanResult>;
  /**
  * Type of reviewer that produced the verdict
  */
  'reviewerType'?: SecurityScanReviewerTypeEnum;
  /**
  * Whether the reviewer concluded ransomware
  */
  'reviewerIsRansomware'?: boolean | null;
  /**
  * Reviewer confidence score
  */
  'reviewerConfidenceScore'?: number | null;
  /**
  * Reviewer reasoning
  */
  'reviewerReason'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "snapshotId",
      "baseName": "snapshotId",
      "type": "string",
      "format": ""
    },
    {
      "name": "conclusion",
      "baseName": "conclusion",
      "type": "SecurityScanConclusionEnum",
      "format": ""
    },
    {
      "name": "createdTime",
      "baseName": "createdTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "confidenceScore",
      "baseName": "confidenceScore",
      "type": "number",
      "format": "float"
    },
    {
      "name": "justification",
      "baseName": "justification",
      "type": "string",
      "format": ""
    },
    {
      "name": "detectorType",
      "baseName": "detectorType",
      "type": "SecurityScanDetectorTypeEnum",
      "format": ""
    },
    {
      "name": "totalEvidenceCount",
      "baseName": "totalEvidenceCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "results",
      "baseName": "results",
      "type": "Array<SecurityScanResult>",
      "format": ""
    },
    {
      "name": "reviewerType",
      "baseName": "reviewerType",
      "type": "SecurityScanReviewerTypeEnum",
      "format": ""
    },
    {
      "name": "reviewerIsRansomware",
      "baseName": "reviewerIsRansomware",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "reviewerConfidenceScore",
      "baseName": "reviewerConfidenceScore",
      "type": "number",
      "format": ""
    },
    {
      "name": "reviewerReason",
      "baseName": "reviewerReason",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SecurityScan.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum SecurityScanConclusionEnum {
  Clean = 'CLEAN',
  HighChanceForRansomware = 'HIGH_CHANCE_FOR_RANSOMWARE',
  DataAnomalyDetected = 'DATA_ANOMALY_DETECTED',
  MalwareDetected = 'MALWARE_DETECTED'
}
export enum SecurityScanDetectorTypeEnum {
  Malware = 'MALWARE',
  RansomwareBehavior = 'RANSOMWARE_BEHAVIOR',
  DataAnomaly = 'DATA_ANOMALY'
}
export enum SecurityScanReviewerTypeEnum {
  NoReview = 'NO_REVIEW',
  Llm = 'LLM'
}

